import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout";
import React from "react";
import ScrollToTop from "./components/scroll-to-top";

const LandingPage = React.lazy(() => import("./webpages/landing-page"));
const Approach = React.lazy(() => import("./webpages/approach"));
const ContactPage = React.lazy(() => import("./webpages/contact"));
const Pricing = React.lazy(() => import("./webpages/price"));
const How = React.lazy(() => import("./webpages/how-it-works"));
const Premium = React.lazy(() => import("./webpages/premium"));
function App() {

  return (
    <React.Suspense
      fallback={
        <div className="flex justify-center items-center font-bold text-blue h-screen">
          Loading...
        </div>
      }
    >
      <ScrollToTop />
      <Routes>
        {/* Layout wrapper */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="home" replace />} />
          <Route path="home" element={<LandingPage />} />
          <Route path="approach" element={<Approach />} />
          <Route path="how" element={<How />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="price" element={<Pricing />} />
          <Route path="premium" element={<Premium />} />
        </Route>
      </Routes>
    </React.Suspense>
  );
}

export default App;
